module.exports = __webpack_public_path__ + "static/media/26.198f77db.wav";